// Utility: communityFlags
// Stateless helpers to derive flags from community data using enums

import { CommunityType } from 'es-shared-types/enums';

/**
 * Returns true when community type is Citizen Energy Community (16b)
 */
export function isMultiDso(communityType: CommunityType | string | undefined | null): boolean {
  return communityType === CommunityType.CITIZEN;
}

/**
 * Returns true for ECNs that should skip wire info section in billing */
export function shouldSkipWireInfo(ecn: string | undefined | null): boolean {
  return ecn === 'GC104486' || ecn === 'GC105599';
}

/**
 * Returns true when the community imposes SME restrictions (e.g., 16c)
 */
export function hasMemberRestrictionsSme(communityType: CommunityType | string | undefined | null): boolean {
  return communityType === CommunityType.REGIONAL;
}

/**
 * Returns true when member join is not available (e.g., 16a)
 */
export function isNoMemberJoin(communityType: CommunityType | string | undefined | null): boolean {
  return communityType === CommunityType.LOCAL;
}


